'use client';

import { forwardRef } from 'react';
import MuiSwitch, { type SwitchProps as MuiSwitchProps } from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

export interface SwitchProps extends MuiSwitchProps {
  label?: string;
}

export const Switch = forwardRef<HTMLButtonElement, SwitchProps>(({ label, ...props }, ref) => {
  if (label) {
    return <FormControlLabel control={<MuiSwitch ref={ref} {...props} />} label={label} />;
  }

  return <MuiSwitch ref={ref} {...props} />;
});

Switch.displayName = 'Switch';
